//cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import { companyCN } from '@/locales/langs/modules/company';
const cn = {
  message: {
    hello: '你好，世界',
  },
  company: companyCN,
  ...zhLocale,
};

export default cn;
